import {createSettingsParams, ISettingsParam, SettingsParamType} from '@wix/tpa-settings';
import {DataType, SettingTypeMetadata} from '@wix/editor-platform-ooi-metadata-resolver';
import type {TranslationFunction} from 'i18next';
import {ISettingsParams} from '../../domain/utils/settings.utils';
import {SideCartParamNames} from '../../common/constants';

export type ISideCartPublicData = Partial<{[k in keyof ISettingsParams<typeof settingsParams>]: string | {}}>;

export const settingsParams: Record<string, ISettingsParam> = {
  [SideCartParamNames.CART_TITLE]: {
    key: SideCartParamNames.CART_TITLE,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.title.label'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.title.label'),
      },
    }),
  },
  [SideCartParamNames.CART_DISCLAIMER_TEXT]: {
    key: SideCartParamNames.CART_DISCLAIMER_TEXT,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.settingsPanel.textTab.disclaimer.placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.settingsPanel.textTab.disclaimer.placeholder'),
      },
    }),
  },
  [SideCartParamNames.CART_EMPTY_CART]: {
    key: SideCartParamNames.CART_EMPTY_CART,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.cartEmpty.emptyState'),
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.cartEmpty.emptyState'),
      },
    }),
  },
  [SideCartParamNames.SIDE_CART_CART_BUTTON]: {
    key: SideCartParamNames.SIDE_CART_CART_BUTTON,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.settingsPanel.textTab.goToCart.placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.settingsPanel.textTab.goToCart.placeholder'),
      },
    }),
  },
  [SideCartParamNames.SIDE_CART_CHECKOUT_BUTTON]: {
    key: SideCartParamNames.SIDE_CART_CHECKOUT_BUTTON,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.settingsPanel.textTab.goToCheckout.placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.settingsPanel.textTab.goToCheckout.placeholder'),
      },
    }),
  },
  [SideCartParamNames.SIDE_CART_ADD_PROMO_CODE_LINK]: {
    key: SideCartParamNames.SIDE_CART_ADD_PROMO_CODE_LINK,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.coupon.addButton.label'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.coupon.addButton.label'),
      },
    }),
  },
  [SideCartParamNames.SIDE_CART_PROMO_CODE_INPUT_PLACEHOLDER]: {
    key: SideCartParamNames.SIDE_CART_PROMO_CODE_INPUT_PLACEHOLDER,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.couponInput.placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.couponInput.placeholder'),
      },
    }),
  },
  [SideCartParamNames.SIDE_CART_ADD_NOTE_LINK]: {
    key: SideCartParamNames.SIDE_CART_ADD_NOTE_LINK,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.buyerNoteAddButton.label'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.buyerNoteAddButton.label'),
      },
    }),
  },
  [SideCartParamNames.SIDE_CART_INSTRUCTIONS_TEXT]: {
    key: SideCartParamNames.SIDE_CART_INSTRUCTIONS_TEXT,
    type: SettingsParamType.Text,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('sideCart.buyerNote.placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('sideCart.buyerNote.placeholder'),
      },
    }),
  },
};

export default createSettingsParams<ISettingsParams<typeof settingsParams>>(settingsParams);
